import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export const CountdownBar: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 15,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="bg-emerald-700 text-white py-3 px-4 text-center" data-id="element-6">
      <div className="flex items-center justify-center gap-2 text-sm font-medium" data-id="element-7">
        <Clock className="w-4 h-4" data-id="element-8" />
        <span data-id="element-9">Oferta termina en:</span>
        <span className="font-mono font-bold" data-id="element-10">
          {formatNumber(timeLeft.hours)}:{formatNumber(timeLeft.minutes)}:
          {formatNumber(timeLeft.seconds)}
        </span>
      </div>
    </div>;
};